import React, { useEffect, useState } from 'react';

type Props = {
    ClosePopup: Function;
    documentUrl: string;
};
const ClientDocumentPopup = (props: Props) => {

    const closePopup = (status?: string) => {
        if (props.ClosePopup) {
            props.ClosePopup(status);
        }
    }
    useEffect(() => {
        console.log('ClientDocumentPopup', props.documentUrl)
    }, [])

    const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(props.documentUrl)}&embedded=true`;

    return (
        <div className="popup-wrapper">
            <section className="popup-window new-lead rtl">
                <div className="close-icon pointer" onClick={() => closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            {props.documentUrl}
                        </div>
                    </div>
                    <div className="popup-body">
                        {props.documentUrl && props.documentUrl.length > 0 && (props.documentUrl.includes('.pdf') || props.documentUrl.includes('.PDF') || props.documentUrl.includes('.png') || props.documentUrl.includes('.jpg')
                        || props.documentUrl.includes('.jpeg') || props.documentUrl.includes('.JPG')|| props.documentUrl.includes('.PNG') || props.documentUrl.includes('.JPEG')) ?
                            <iframe src={props.documentUrl} style={{ width: '100%', height: '750px' }} />
                            : <iframe src={viewerUrl} style={{ width: '100%', height: '750px' }} />
                        }
                        {/* <iframe src={viewerUrl} style={{ width: '100%', height: '700px' }} /> */}
                        {/* <iframe src={`https://docs.google.com/gview?url=${encodeURIComponent(props.documentUrl)}&embedded=true`} style={{width:'100%',height:'700px'}}></iframe> */}

                    </div>
                    <div className="popup-footer">
                        <button className="button white blue-border" onClick={(e: any) => closePopup()}>
                            סגור
                        </button>
                    </div>
                </div>
            </section>
        </div>

    )
}

export default ClientDocumentPopup;
